// import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ModalTable from "../../../../../components/utils/modalTable/modalTable";
// import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
// import { date } from "yup";
// import { Print } from "@mui/icons-material";
// import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
// import { useNavigate } from "react-router-dom";
// import OtToOtTransferTable from "../../../../../components/utils/modalTable/otToOtTransferTable";

// const OtTootTransferReports = () => {
//   const classes = useStyle()
//   const dispatch = useDispatch();
//   const pageOption = [10, 25, 50, 100];
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//   const [pageCount, setPageCount] = useState(0);
//   const [data, setData] = useState([]);
//   const [rowData, setRowData] = useState(null)
//   const [supplier, setSupplier] = useState([]);
//   const navigate = useNavigate()
//   const[salesLines , setSalesLines] = useState([])
//   const [open , setOpen] = useState(false)
//   const [companyData , setCompanyData] = useState([])
//   const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//     const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
//     const roleId = localStorage.getItem("role_id")
//     const outletName = localStorage.getItem('outlet_name')
//     const outletId = localStorage.getItem('outlet_id')
//   const [dateLimit, setDateLimit] = useState({
//     fromDate : moment().subtract(1 , 'months').format(),
//     toDate :  moment().format()
//   })
//   const[cust, setCust] = useState(null)
//   const fixedOutlet = { id: outletId, fullname: outletName };
//   const onEdit = (e) => {
//     console.log(e.row)
//     setSalesLines(e.row.closing_expences_lines)
//     setRowData(e.row)
//     setOpen(true)
//   }
//   console.log(salesLines)
// const columns = [
//   {
//     field : 'sno',
//     headerName : 'S.no',
//     minWidth : 70,
//     headerAlign : 'center',
//     align : 'center',
//     sortable: false
//   },
//   {
//     field: "date1",
//     headerName: "Date",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "docNo",
//     headerName: "Doc NO",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field:"fromOutlet",
//     headerName: "From Outlet Name",
//     minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "toOutlet",
//     headerName: "To Outlet Name",
//     minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   // {
//   //   field: "mobile",
//   //   headerName: "Mobile",
//   //   minWidth: 130,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   sortable: false,
//   // },
//   {
//     field: "amount",
//     headerName: "Amount",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "status",
//     headerName: "Status",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => {
//       const isOwn = params.row.is_owned;
//       const isApproved = params.row.is_approved;
  
//       // When is_own is true and is_approved is false, show "OWN" in red
//       if (isOwn && !isApproved) {
//         return (
//           <span>
//             OWN
//           </span>
//         );
//       }
//       // When is_own is false and is_approved is false, show "Unapproved" in red
//       else if (!isOwn && !isApproved) {
//         return (
//           <span>
//             Unapproved
//           </span>
//         );
//       }
//       // When is_own is false and is_approved is true, show "Approved" in red
//       else if (!isOwn && isApproved) {
//         return (
//           <span>
//             Approved
//           </span>
//         );
//       }
//       // When is_own is true and is_approved is true, show "OWN" in red
//       else if (isOwn && isApproved) {
//         return (
//           <span>
//             OWN
//           </span>
//         );
//       } else {
//         return null; // Or you can return a default value if needed
//       }
//     }
//   },
//   {
//     field: "approvedate1",
//     headerName: "Approved Date",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
  
  
  
  
  
  
//   // {
//   //   field: "expences_amount",
//   //   headerName: "Expences Amount",
//   //   minWidth: 130,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   sortable: false,
//   // },
//   // {
//   //   field: "closing_balance",
//   //   headerName: "Closing Balance",
//   //   minWidth: 130,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   sortable: false,
//   // },
//   // {
//   //   field: "tot",
//   //   headerName: "Total",
//   //   minWidth: 130,
//   //   headerAlign: "center",
//   //   align: "right",
//   //   sortable: false,
//   //   renderCell: (params) => (
//   //     <strong>{params.value}</strong>
//   //   ),
//   // },
//   {
//     field: "view",
//     headerName: "View",
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     disableExport: true ,
//     renderCell: (params) => {
//       return (
//         <div>
//           <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
//             {/* <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton> */}

//         </div>
        
//       );
//     },
//   },
// ]
// // useEffect(() => {
// //   axios.get(`/v1/outlet/info/${outletId}`)
// //   .then((res) => {console.log(res.data);setCompanyData(res.data)})
// //   .catch((err) => {console.log(err)})
// //     },[])
//   function handleThermal(e){
//     console.log('Working!',e)
//     console.log(e)
//     const textData = {
//       tot:e.tot,
//       date:e.documentDate,
//       employee:e.salesManName,
//       opening_balance:e.opening_balance,
//       expences_amount:e.expences_amount
//     }
//     const tableData = _.map(e.closing_expences_lines, ((val , idx)=>({ 
//       sno:++idx,
//      denomination:val.denomination,
//      count:val.count,
//      total:val.total
//     })))
//     console.log(tableData)
//     console.log(textData)
   
//     dispatch(setThermalData({
//       tableData : tableData,
//       TotalData : textData,
//       companyInfo:cust
//     }))      
//     dispatch(onPressButton())
//     const name = `ExpenseBill`
//     navigate(`/expenseClose/${name}`)  
   
//         }
//         console.log(cust)
// const rows = _.map(data,(val,idx)=>({
//   id: val.id,
//   sno: idx+1,
//   date1 : moment(val.docdate).format("DD-MM-YYYY"),
//   docNo:val.docno,
//   fromOutlet : val.from_outlet_fullname,
//   toOutlet:val.to_outlet_fullname,
//   otCode:val.code,
//   party : val.fullname,
//   amount:val.amount,
//   mobile:val.mobile,
//   tot: parseFloat(val.amount).toFixed(2),
//   closing_expences_lines:val.outlet_to_outlet_transfer_lines,
//   closing_balance:val.closing_balance,
//   is_approved:val.is_approved,
//   is_owned:val.is_owned,
//   documentDate:moment(val.date).format("DD-MM-YYYY"),
//   approvedate1: val.is_approved_date 
//   ? moment(val.is_approved_date).format("DD-MM-YYYY") 
//   : "-",
// }))
// const props = {
//   columns : columns,
//   rows : rows,
//   page: page,
//   setPage: setPage,
//   rowsPerPage: rowsPerPage,
//   setRowsPerPage: setRowsPerPage,
//   pageCount: pageCount,
//   pageOption: pageOption,
//   totalAmount:totalAmount,
//   totalFlag:totalFlag
// }
// useEffect(() => {
//   // Calculate total balance amount
//   setTotalFlag(true)
//   let total = 0;

//   data.forEach(val => {
//       total += parseFloat(val.amount);
//   });
//   setTotalAmount(total.toFixed(2));
// }, [data]);
// const tableHeadData = [
//   { id:1, label: "S No" },
//   { id:2, label: "Date" },
//   { id:3 , label:"barcode"},
//   { id:4 , label : "Product Name"},
//   { id:5, label:"QTY"},
//   { id:6 , label:"total"},
// ];
// console.log(salesLines)
// const tableBodyData = _.map(salesLines, (val,idx) => ({
//   id:idx,
//   sNo:idx+1,
//   count:val.qty,
//   denomination:val.barcode,
//   proName: val.pro_name,
//   date:moment(val.docdate).format("DD-MM-YYYY"),
//   total:val.mrp,
// }))
//   function handleChange(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
//   function getSupplierData() {
//     axios
//       .get("/v1/outlet/list/1")
//       .then((res) => {
//         setSupplier(res.data);
//         _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }
// function handleSalesReturn(){
//   const postData = {
//     from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//     to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
//       customer: cust!==null ? cust.id : fixedOutlet.id,
//       fillter: 4,
//   }
//   axios.post('/v1/reports/outlet/to/outlet/transfer', postData)
//   .then(res=>{
//     setData(res.data)
//     setPageCount(res.data.length)
//   })
//   .catch(err=>{
//     dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
//     setData([])
//   })
// }
// console.log(data)
//   useEffect(() => {
//     getSupplierData();
//   }, []);
  
//   useEffect(()=>{
//     if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
//       handleSalesReturn()
//       console.log('Vanthuden')
//     }
//   },[rowsPerPage, page, dateLimit, cust])
//   console.log(roleId != 2 )
//   return (
//     <Fragment>
//       <Helmet><title>Ot to ot transfer Reports</title></Helmet>
//       <Typography variant="h6">Ot to ot transfer Reports</Typography>
//       <Grid container spacing={2} className="p-2 pt-2">
//         <Grid item md={3}>
//           <Autocomplete 
//             size="small"
//             value={cust}
//             options={supplier}
//             onChange={(e,value)=>setCust(value)}
//             getOptionLabel={option=>option.fullname}
//             disabled={roleId != 1 && roleId != 2} 
//             renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
//           />
//         </Grid>
//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               disabled={roleId != 1 && roleId != 2}
//               format="DD-MM-YYYY"
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               disabled={roleId != 1 && roleId != 2}
//               format="DD-MM-YYYY"
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//       </Grid>
//       <CustomTable props={props}/>
//       <Backdrop open={open} sx={{zIndex:9999}}>
//         <OtToOtTransferTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
//       </Backdrop>
//     </Fragment>
//   );
// };

// export default memo(OtTootTransferReports);


import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
import { date } from "yup";
import { PictureAsPdf, Print } from "@mui/icons-material";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";
import OtToOtTransferTable from "../../../../../components/utils/modalTable/otToOtTransferTable";
import { setPDFData } from "../../../../../components/hooks/printPdf/pdfData";

const OtTootTransferReports = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const navigate = useNavigate()
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [companyData , setCompanyData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const roleId = localStorage.getItem("role_id")
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , 'months').format(),
    toDate :  moment().format()
  })
  const[cust, setCust] = useState(null)
  // const[status, setStatus] = useState()
  const [status, setStatus] = useState({ id: 4, fullname: "All" }); // Default to "All"

  const fixedOutlet = { id: outletId, fullname: outletName };
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.closing_expences_lines)
    setRowData(e.row)
    setOpen(true)
  }
  console.log(salesLines)
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "docNo",
    headerName: "Doc NO",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"fromOutlet",
    headerName: "From Outlet Name",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "toOutlet",
    headerName: "To Outlet Name",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  // {
  //   field: "mobile",
  //   headerName: "Mobile",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      const isOwn = params.row.is_owned;
      const isApproved = params.row.is_approved;
  
      // When is_own is true and is_approved is false, show "OWN" in red
      if (isOwn && !isApproved) {
        return (
          <span>
            OWN
          </span>
        );
      }
      // When is_own is false and is_approved is false, show "Unapproved" in red
      else if (!isOwn && !isApproved) {
        return (
          <span>
            Unapproved
          </span>
        );
      }
      // When is_own is false and is_approved is true, show "Approved" in red
      else if (!isOwn && isApproved) {
        return (
          <span>
            Approved
          </span>
        );
      }
      // When is_own is true and is_approved is true, show "OWN" in red
      else if (isOwn && isApproved) {
        return (
          <span>
            OWN
          </span>
        );
      } else {
        return null; // Or you can return a default value if needed
      }
    }
  },
  {
    field: "approvedate1",
    headerName: "Approved Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  
  
  
  
  
  
  // {
  //   field: "expences_amount",
  //   headerName: "Expences Amount",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "closing_balance",
  //   headerName: "Closing Balance",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "tot",
  //   headerName: "Total",
  //   minWidth: 130,
  //   headerAlign: "center",
  //   align: "right",
  //   sortable: false,
  //   renderCell: (params) => (
  //     <strong>{params.value}</strong>
  //   ),
  // },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
            {/* <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton> */}
          <IconButton size="small" onClick={()=>handlePDF(params.row)}><Print sx={{fontSize: 16}} /></IconButton>

        </div>
        
      );
    },
  },
]
// useEffect(() => {
//   axios.get(`/v1/outlet/info/${outletId}`)
//   .then((res) => {console.log(res.data);setCompanyData(res.data)})
//   .catch((err) => {console.log(err)})
//     },[])
  function handleThermal(e){
    console.log('Working!',e)
    console.log(e)
    const textData = {
      tot:e.tot,
      date:e.documentDate,
      employee:e.salesManName,
      opening_balance:e.opening_balance,
      expences_amount:e.expences_amount
    }
    const tableData = _.map(e.closing_expences_lines, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    console.log(tableData)
    console.log(textData)
   
    dispatch(setThermalData({
      tableData : tableData,
      TotalData : textData,
      companyInfo:cust
    }))      
    dispatch(onPressButton())
    const name = `ExpenseBill`
    navigate(`/expenseClose/${name}`)  
   
        }

  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

const convertNumber = (num) => {
  if (num === 0) return 'Zero';

  let words = '';
  for (let i = 0; num > 0; i++) {
    if (num % 1000 !== 0) {
      words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
    }
    num = Math.floor(num / 1000);
  }
  return words.trim();
};

const convertHundreds = (num) => {
  if (num >= 100) {
    return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
  } else {
    return convertTens(num);
  }
};

const convertTens = (num) => {
  if (num < 10) return units[num];
  else if (num < 20) return teens[num - 10];
  else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
};

  
  function handlePDF(e) {
    console.log("Event Data:", e);
  
    if (!e.closing_expences_lines || !Array.isArray(e.closing_expences_lines)) {
      console.error("Invalid sales_lines data");
      dispatch(setSnackbar(true, "error", "Invalid sales lines data"));
      return;
    }
  
    const tableData = e.closing_expences_lines.map((line) => ({
      pro_name: line.pro_name || 'N/A',
      pur_rate: line.rate || 0,
      qty: line.qty || 0,
      disc1: line.dis_per || 0,
      cgstPerc: line.gst_per || 0,
      cgstAmnt: line.gst_amt || 0,
      totalAmt: (line.rate || 0) * (line.qty || 0),
      hsn: line.hsn || 0,
      docNo: line.docno
    }));
  
    const TotalData = {
      cess_amt: e.cess || 0,
      sub_total: e.sub_total || 0,
      gst: e.gst_Amt || 0,
      totalAmount: e.tot || 0,
      roundOff: e.roff || 0,
    };
  
    console.log("Table Data:", tableData);
    console.log("Total Data:", TotalData);
    // docNo:val.docno,
    axios
      .post(`/v1/outlet_to_outlet_transfer/getall`, { docno: e.docNo })
      .then((res) => {
        console.log("API Response:", res.data);
  
        dispatch(setThermalData({
          tableData: tableData,
          TotalData: TotalData,
          companyInfo: res.data,
          docno:e.docno,
          totalText: convertNumber(e.tot || 0),
          // title: e.outletTypeName === 'OWN' ? 'Delivery challan' : 'Tax Invoice',
        }));
            dispatch(onPressButton());
  
        const name = `BillNo_${e.docNo}`;
        navigate(`/otTransfer/${name}`);
        // navigate(`/invoiceReport/${name}`);
      })
      .catch((err) => {
        console.error("API Error:", err.response?.data?.errors[0]?.message || "Unknown Error");
        dispatch(setSnackbar(true, "error", err.response?.data?.errors[0]?.message || "Error processing request"));
      });
  }
        console.log(cust)
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.docdate).format("DD-MM-YYYY"),
  docNo:val.docno,
  fromOutlet : val.from_outlet_fullname,
  toOutlet:val.to_outlet_fullname,
  otCode:val.code,
  party : val.fullname,
  amount:parseFloat(val.amount).toFixed(0),
  mobile:val.mobile,
  tot: parseFloat(val.amount).toFixed(0),
  closing_expences_lines:val.outlet_to_outlet_transfer_lines,
  closing_balance:val.closing_balance,
  is_approved:val.is_approved,
  is_owned:val.is_owned,
  documentDate:moment(val.created_at).format("DD-MM-YYYY"),
  approvedate1: val.is_approved_date 
  ? moment(val.is_approved_date).format("DD-MM-YYYY") 
  : "-",
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
console.log(props,"propspropspropsprops");


useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Date" },
  { id:3 , label:"barcode"},
  { id:4 , label : "Product Name"},
  { id:5, label:"QTY"},
  { id:6 , label:"total"},
];
console.log(salesLines)
const tableBodyData = _.map(salesLines, (val,idx) => ({
  id:idx,
  sNo:idx+1,
  count:parseFloat(val.qty).toFixed(0),
  denomination:val.barcode,
  proName: val.pro_name,
  date:moment(val.docdate).format("DD-MM-YYYY"),
  total:parseFloat(val.mrp).toFixed(0),
}))
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleSalesReturn(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : fixedOutlet.id,
      fillter: status.id,
      // filter: status.id,

  }
  axios.post('/v1/reports/outlet/to/outlet/transfer', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}


console.log(data)
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust,status])
  console.log(roleId != 2 )
  return (
    <Fragment>
      <Helmet><title>Ot to ot transfer Reports</title></Helmet>
      <Typography variant="h6">Ot to ot transfer Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        {/* <Grid item xs={12} sm={4} lg={3}>
    <Autocomplete
      size="small"
      options={[
        { id: 0, fullname: "All" },
        { id: 1, fullname: "OWN" },
        { id: 2, fullname: "Approved" },
        { id: 3, fullname: "Unapproved" },
      ]}
      disableClearable
      value={status}
      onChange={(e, value) => setStatus(value)} // Update status
      getOptionLabel={(option) => option.fullname}
      renderInput={(params) => <TextField {...params} label="Select Status" />}
    />
  </Grid> */}
  <Grid item xs={12} sm={4} lg={3}>
        <Autocomplete
          size="small"
          options={[
            { id: 4, fullname: "All" },
            { id: 1, fullname: "OWN" },
            { id: 2, fullname: "Approved" },
            { id: 3, fullname: "Unapproved" },
          ]}
          disableClearable
          value={status}
          onChange={(e, value) => setStatus(value)} // Update status on selection
          getOptionLabel={(option) => option.fullname}
          renderInput={(params) => <TextField {...params} label="Select Status" />}
        />
      </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <OtToOtTransferTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  );
};

export default memo(OtTootTransferReports);

